<template>
  <div class="maincontainer" v-infinite-scroll="loadMore" infinite-scroll-distance="10">
    <template v-if="ntask != null">
      <taskform :ntask="ntask"  :loaded="loaded" v-on:saveTask="saveTaskClicked(ntask)" :customers="customersList" :workerItems="workerItems" :workersLoaded="workersLoaded" v-on:cloneTask="cloneTask" ref="taskform"></taskform>
    </template>
    <div class="row">
        <div class="col offset-s8 s4 label" style="padding-bottom: 20px;">
          <a v-if="role == 'ddd_admin' || (role == 'ddd_worker' && extended_privileges)" class="waves-effect waves-light btn-large green"  style="border-radius: 8px; line-height: 2.5; height: 35px;" v-on:click="edit = false; " href="#/interventions/new">{{$t('interventions.add')}}</a>
          <a class="waves-effect waves-light btn-large green"  style="border-radius: 8px; line-height: 2.5; height: 35px;" :href="'/interventions/'+fromts+'/'+tots+'.xlsx'" :download="$t('interventions.file_title')+ fromTsFormatted + ' - ' + toTsFormatted  +'.xlsx'">{{$t('interventions.xls')}}</a>
        </div>
    </div>
    <table>
    <thead style="position: sticky; top: 100px;">
      <tr>
        <th style="width: 1%;" v-if="role == 'ddd_admin' || (role == 'ddd_worker')"></th>
        <th style="width: 5%;">
          <p v-on:click="set_order('id')" class="cursor-pointer">
            <span>{{$t('interventions.number')}}</span>
            <i class="material-icons dp6" v-if="orderby == 'id' && order == 'desc'">arrow_drop_down</i> 
            <i class="material-icons dp6" v-if="orderby == 'id' && order == 'asc'">arrow_drop_up</i>
            <div class="input-field"><input v-model="idsearch"/></div>
          </p>
        </th>
        <th style="min-width: 30ch;" class="cursor-pointer">
            <p v-on:click="set_order('date')">
              <span>{{$t('interventions.date_done')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'date' && order == 'asc'">arrow_drop_up</i>
            </p>
            <select v-model="rangeSelected">
              <option value="currentMonth">{{$t('calendar.current_month')}}</option>
              <option value="prevMonth">{{$t('calendar.prev_month')}}</option>
              <option value="lastThreeMonths">{{$t('calendar.last_three_months')}}</option>
              <option value="currentYear">{{$t('calendar.current_year')}}</option>
              <option value="prevYear">{{$t('calendar.previous_year')}}</option>
              <option value="other">{{$t('calendar.other_range')}}</option>
            </select>
            <div class="row" v-if="rangeSelected == 'other'">
              <div class="col s6 input-field" style="padding-left: 0px;padding-right: 5px; min-width: 13ch;">
                <input type="date" v-model="fromSelected"/>
                <button class="waves-effect waves-light btn-large gray" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%" v-on:click="cancelChanges()">{{$t('calendar.cancel')}}</button>
              </div>
              <div class="col s6 input-field" style="padding-right: 5px;padding-left: 5px; min-width: 13ch;">
                <input type="date" v-model="toSelected"/>
                <button class="waves-effect waves-light btn-large green" style="border-radius: 8px; line-height: 2.5; height: 35px; padding-left: 0px;padding-right: 0px; width: 100%" v-on:click="applyChanges()">{{$t('calendar.apply')}}</button>
              </div>
            </div>
        </th>
        <th>
          <p v-on:click="set_order('worker_name')" class="cursor-pointer">
            <span>{{$t('interventions.types')}}</span>
            <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'desc'">arrow_drop_down</i> 
            <i class="material-icons dp6" v-if="orderby == 'worker_name' && order == 'asc'">arrow_drop_up</i>
          </p>
          <selector  v-model="selected_kinds" :items="kinds" identifier="kinds"></selector>
        </th>
        <th>
          <p v-on:click="set_order('place_name')" class="cursor-pointer">
            <span>{{$t('interventions.contractor')}}</span>
            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
          </p>
          <div class="input-field"><input v-model="customersearch"/></div>
        </th>
        <th>
          <p v-on:click="set_order('place_name')" class="cursor-pointer">
            <span>{{$t('interventions.place')}}</span>
            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'desc'">arrow_drop_down</i>
            <i class="material-icons dp6" v-if="orderby == 'place_name' && order == 'asc'">arrow_drop_up</i>
          </p>
          <div class="input-field"><input v-model="addrsearch"/></div>
        </th>
        <th v-if="role != 'ddd_customer'">
          <p v-on:click="set_order('worker_ids')" class="cursor-pointer">
            <span>{{$t('interventions.worker')}}</span>
            <i class="material-icons dp6" v-if="orderby == 'worker_ids' && order == 'desc'">arrow_drop_down</i>
            <i class="material-icons dp6" v-if="orderby == 'worker_ids' && order == 'asc'">arrow_drop_up</i>
          </p>
          <selector  v-model="selected_workers" :items="workerItems" identifier="workerselector"></selector>
        </th>
        <th v-if="role != 'ddd_customer'">
          <p v-on:click="set_order('price')" class="cursor-pointer">
            <span>{{$t('interventions.price')}}</span>
              <i class="material-icons dp6" v-if="orderby == 'price' && order == 'desc'">arrow_drop_down</i> 
              <i class="material-icons dp6" v-if="orderby == 'price' && order == 'asc'">arrow_drop_up</i>
          </p>
          <div class="input-field"><input v-model="pricesearch"/></div>
        </th>
        <th></th>
      </tr>
    </thead>

    <tbody v-if="items.length > 0 && loaded">
      <template  v-for="(intervention, index) in items">
        <tr :key="intervention.id">
          <td v-if="role == 'ddd_admin' || (role == 'ddd_worker')">
             <colorselector :color="intervention.color" v-on:colorSelected="changeColor(intervention, $event)"/>
         </td>
         <td>{{intervention.number}}</td>
          <td>
            <template v-if="intervention.task_id == null">
              {{intervention.date | formatDate}}
            </template>
            <template v-else>
               <a class="cursor-pointer" v-on:click="showTask(intervention.task_id)">{{intervention.date | formatDate}}</a>
            </template>
          </td>
          <td>{{intervention.types | nameTypes(intervention.other_what)}}</td>
          <td>{{[[intervention.address.name, intervention.address.street].filter((tx)=> tx != undefined && tx.length > 0).join(" "), [intervention.address.postal_code ,intervention.address.city].filter((tx)=> tx != undefined && tx.length > 0).join(" ")].filter((tx)=> tx != undefined && tx.length > 0).join(", ")}}</td>
          <td>{{[[intervention.address2.name, intervention.address2.street].filter((tx)=> tx != undefined && tx.length > 0).join(" "), [intervention.address2.postal_code ,intervention.address2.city].filter((tx)=> tx != undefined && tx.length > 0).join(" ")].filter((tx)=> tx != undefined && tx.length > 0).join(", ")}}</td>
          <td v-if="role != 'ddd_customer'">{{intervention.worker_ids | nameByIds(workers)}}</td>
          <td v-if="role != 'ddd_customer'">{{intervention.net_price ? intervention.net_price : ""}} {{intervention.price}}  ({{payment_methods[intervention.payment_method]}})</td>
          <td><router-link :to='"/interventions/" + intervention.id'><i class="material-icons dp6">list_alt</i></router-link></td>
        </tr>
      </template>
    </tbody>
    <preloader v-if="loaded == false || busy" n="7"/>
  </table>
  <template v-if="items.length == 0 && loaded == true"><p style="font-size: 12px;">{{$t('interventions.not_found')}}</p></template>
</div>
</template>

<script>
import Vue2Filters from 'vue2-filters'
import axios from 'axios';
import moment from 'moment';
import VueCookies from 'vue-cookies'

export default {
  props: { role: String, extended_privileges: Boolean },
  data: function () {
    var selRange =  (this.$cookies.get('interventionRange') || "currentMonth");
    var ros = {
      currentMonth: {from: moment().startOf("month").format("YYYY-MM-DD"), to: moment().endOf("month").format("YYYY-MM-DD")},
      prevMonth: {from: moment().subtract(1,'months').startOf("month").format("YYYY-MM-DD"), to: moment().subtract(1,'months').endOf("month").format("YYYY-MM-DD")},
      lastThreeMonths: {from: moment().subtract(3,'months').startOf("month").format("YYYY-MM-DD"), to: moment().endOf("month").format("YYYY-MM-DD")},
      currentYear: {from: moment().startOf("year").format("YYYY-MM-DD"), to: moment().endOf("year").format("YYYY-MM-DD")},
      prevYear: {from: moment().subtract(1,'years').startOf("year").format("YYYY-MM-DD"), to: moment().subtract(1,'years').endOf("year").format("YYYY-MM-DD")},
      other: {from: moment().startOf("day").format("YYYY-MM-DD"), to: moment().endOf("day").format("YYYY-MM-DD")}
    };
    return {
      order: 'desc',
      orderby: 'number',
      interventions: [],
      instances: [],
      workers: [],
      workerItems: [],
      places: [],
      selected_kinds: JSON.parse(this.$cookies.get('selectedKinds') || "[]"),
      selected_workers:  JSON.parse(this.$cookies.get('selectedWorkers') || "[]"),
      rangeSelected: selRange,
      lastRange: selRange,
      from: ros[selRange].from,
      to: ros[selRange].to,
      fromSelected: ros[selRange].from,
      toSelected: ros[selRange].to,
      fromts: 0,
      tots: 0,
      fromTsFormatted: '',
      toTsFormatted: '',
      rangeOptions: ros,
      loaded: false,
      workersLoaded: false,
      kinds: [
        {name: this.$t('interventions.deratization'), value: "deratization"},
        {name: this.$t('interventions.disinsection'), value: "disinsection"},
        {name: this.$t('interventions.disinfection'), value: "disinfection"},
        {name: this.$t('interventions.other'), value: "other"}
      ],
      payment_methods: {
        "cash": this.$t('tasks.payment_methods.cash'),
        "transfer": this.$t('tasks.payment_methods.transfer'),
        "card": this.$t('tasks.payment_methods.card'),
        "blik": this.$t('tasks.payment_methods.blik')
      },
      addrsearch: this.$cookies.get('addrsearch') || "",
      customersearch: this.$cookies.get('customersearch') || "",
      idsearch: this.$cookies.get('idsearch') || "",
      pricesearch: this.$cookies.get('pricesearch') || "",
      colors: [ "white", "red", "green", "orange", "blue", "yellow", "violet", "gray", "black" ],
      busy: false,
      noMoreData: false,
      items: [],
      listedItems: [],
      index: 0,
      itemsperpage: 50,
      ntask: null
    }
  },
  watch: {
    rangeSelected: function (val) {
      this.lastRange = val;
      this.from = this.rangeOptions[val].from;
      this.fromSelected = this.rangeOptions[val].from;
      this.to = this.rangeOptions[val].to;
      this.toSelected = this.rangeOptions[val].to;
      this.fetch_interventions(moment(this.from).startOf("day"), moment(this.to).endOf("day"));
      this.reset_list();
      this.$cookies.set('interventionRange', val, 0);
    },
    selected_kinds: function(val){
      this.reset_list();
      this.$cookies.set('selectedKinds', JSON.stringify(val), 0);
    },
    selected_workers: function(val){
      this.reset_list();
      this.$cookies.set('selectedWorkers', JSON.stringify(val), 0);
    },
    idsearch: function(val){
      this.reset_list();
      this.$cookies.set('idsearch', val, 0);
    },
    customersearch: function(val){
      this.reset_list();
      this.$cookies.set('customersearch', val, 0);
    },
    addrsearch: function(val){
      this.reset_list();
      this.$cookies.set('addrsearch', val, 0);
    },
    pricesearch: function(val){
      this.reset_list();
      this.$cookies.set('pricesearch', val, 0);
    }
  },
  created() {
    var that = this;
    this.load_places();
    if(that.rangeSelected == "currentMonth"){
      axios.get('/interventions/last.json').then(response => {
        if(response.data != null){
          var last_time = moment(response.data * 1000);
          if(last_time.isBetween(moment().startOf("month"), moment().endOf("month"))) that.rangeSelected = "currentMonth";
          else if(last_time.isBetween(moment().subtract(1,'months').startOf("month"), moment().subtract(1,'months').endOf("month"))) that.rangeSelected = "prevMonth";
          else if(last_time.isBetween(moment().subtract(3,'months').startOf("month"), moment().endOf("month"))) that.rangeSelected = "lastThreeMonths";
          else if(last_time.isBetween(moment().startOf("year"), moment().endOf("year"))) that.rangeSelected = "currentYear";
          else if(last_time.isBetween(moment().subtract(1,'years').startOf("year"), moment().subtract(1,'years').endOf("year")))
            that.rangeSelected = "prevYear";
          else{
            that.from = last_time.clone().startOf("month").format("YYYY-MM-DD")
            that.fromSelected = last_time.clone().startOf("month").format("YYYY-MM-DD")
            that.to = last_time.clone().endOf("month").format("YYYY-MM-DD")
            that.toSelected = last_time.clone().endOf("month").format("YYYY-MM-DD")
            that.rangeSelected = "other";
          }
          that.fetch_interventions(moment(that.from).startOf("day"), moment(that.to).endOf("day"));
        }
      });
    }else that.fetch_interventions(moment(that.from).startOf("day"), moment(that.to).endOf("day"));
  },
  methods: {
    fetch_interventions: function(a, b){
      this.loaded = false;
      this.fromts = a.unix();
      this.tots = b.unix()
      this.fromTsFormatted = a.format('D.M.YYYY');
      this.toTsFormatted = b.format('D.M.YYYY');
      axios.get('/interventions/'+a.unix()+'/'+b.unix()+'.json').then(response => {
        this.interventions = response.data;
        for(var i in this.interventions){
          var item = this.interventions[i];
          item.keywords = ""+item.address2.name+" "+item.address2.street+" "+item.address2.postal_code;
          item.keywords2 = ""+item.address.name+" "+item.address.street+" "+item.address.postal_code;
        }
        this.loaded = true;
        this.items = [];
        this.noMoreData = false;
        this.busy = false;
        this.loadMore();
        this.reset_list();
      })
      if(this.role != "ddd_customer"){
        axios.get('/workers.json').then(response => {
          this.workers = response.data;
          for(var i in this.workers){
            var item = this.workers[i];
            if(item.active) this.workerItems.push({value: item.id, name: item.name+" "+item.surname});
          }
          this.workersLoaded = true;
        })
      }
    },
    reset_list: function(){
      this.index = 0;
      this.noMoreData = false;
      this.items = this.listItems.slice(0, this.index + this.itemsperpage);
      this.index += this.itemsperpage;
    },
    load_places: async function() {
      var response = await axios.get('/places.json')
      this.places = response.data;
      for (var i in this.places) {
          this.places[i].collapsed = false;
          this.places[i].address_text =  "" + this.places[i].address.street + ""
          var place = this.places[i];
          place.orders_groupped = _.keyBy(place.orders, 'dev_type_id');
          this.places[i].countgroups = _.keyBy(this.places[i].counts, 'device_category');
          if(moment(this.places[i].next_inspection).isAfter(moment())){
              this.places[i].overdone = false
          }else{
              this.places[i].overdone = true
          }
      }
    },
    collapse : function(customer){
      customer.collapsed = !(customer.collapsed);
      this.$forceUpdate();
    },
    cancelChanges: function(){
      this.rangeSelected = this.lastRange;
    },
    applyChanges: function(){
      this.from = this.fromSelected;
      this.to = this.toSelected;
      this.fetch_interventions(moment(this.from).startOf("day"), moment(this.to).endOf("day"));
    },
    set_order: function(order){
      if(this.orderby == order){
        if(this.order == 'desc'){
          this.order = 'asc'
        }else if(this.order == 'asc'){
          this.order = 'desc'
        }
        
      }else{
        this.orderby = order;
      }
      this.reset_list();
    },
    changeColor: function(inter, color){
        axios.put("/interventions/"+inter.id+".json", {color: color})
        inter.color = color
    },
    loadMore() {
      if (this.busy || this.noMoreData) return;
      this.busy = true;
      const nextChunk = this.listItems.slice(this.index, this.index + this.itemsperpage);
      if (nextChunk.length > 0) {
        this.items = [...this.items, ...nextChunk];
        this.index += this.itemsperpage;
      } else {
        this.noMoreData = true; 
      }
      this.busy = false;
    },
    showTask: async function(taskid){
      var resp = await axios.get("/tasks/"+taskid+".json")
      this.ntask = resp.data
      var elems = document.querySelectorAll('.modal');
      this.instances = M.Modal.init(elems, { startingTop: '0%', preventScrolling: true, });
      if(!_.isUndefined(this.instances[0])) this.instances[0].open()
    },
    async saveTaskClicked(task){
        await this.saveTask(task)
        if (this.instances != undefined) {
            if(!_.isUndefined(this.instances[0])) this.instances[0].close()
        }
    },
    saveTask: async function(task) {
        if(moment(task.startsAt).isAfter(task.endsAt)){
            return false;
        } 
        const formData = new FormData();
        formData.append('task[startsAt]', moment(task.startsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
        formData.append('task[endsAt]', moment(task.endsAt).utcOffset(1, false).format('YYYY-MM-DDTHH:mmZZ'));
        formData.append('task[typeof]', task.typeof);
        formData.append('task[payment_method]', task.payment_method || "cash");
        formData.append('task[pricing]', task.pricing);
        if (task.routine) formData.append('task[routine]', true);
        formData.append('task[name]', task.name || "");
        formData.append('task[status]', task.status);
        formData.append('task[reconescance]', task.reconescance);
        formData.append('task[physical_mount]', task.physical_mount);
        formData.append('task[intervention_type_other]', task.intervention_type_other);
        formData.append('task[typeof_other]', task.typeof_other);
        if (_.isUndefined(task.worker_ids) == false) {
            for (var index in _.range(0, task.worker_ids.length)) {
                var worker_id = task.worker_ids[index];
                if(worker_id != -1){
                    formData.append('task[worker_ids][]', worker_id);
                }
            }
        }
        if (_.isUndefined(task.photos) == false) {
            for (var index in _.range(0, task.photos.length)) {
                formData.append('task[media_attributes][' + index + '][image]', task.photos[index].attachment);
                if (task.photos[index].id) {
                    formData.append('task[media_attributes][' + index + '][id]', task.photos[index].id);
                }
                if (task.photos[index].destroy) {
                    formData.append('task[media_attributes][' + index + '][_destroy]', true);
                }
            }
        }
        if (task.typeof == 'intervention') formData.append('task[intervention_type]', task.intervention_type);
        if(_.isUndefined(task.phone_number) == false){
            formData.append('task[phone_number]', task.phone_number);
        }
        if (task.routine == false && (task.typeof == 'other' || task.typeof == 'intervention')) {
            formData.append('task[address_attributes][name]', task.address.name);
            formData.append('task[address_attributes][street]', task.address.street);
            formData.append('task[address_attributes][city]', task.address.city);
            formData.append('task[address_attributes][postal_code]', task.address.postal_code);
        } else {
            formData.append('task[place_id]', task.place_id);
        }
        if (task.id) {
            var response = await axios.put('/tasks/' + task.id + '.json', formData)
            var task = _.cloneDeep(response.data)
        } else {
            var response = await axios.post('/tasks.json', formData)
            var task = _.cloneDeep(response.data)   
        }
        task.startsAt = moment(task.startsAt).format('YYYY-MM-DDTHH:mm')
        task.endsAt = moment(task.endsAt).format('YYYY-MM-DDTHH:mm')
        this.$refs.taskform.saving = false;
    },
  cloneTask: function(task){
    this.instances[0].close()
    var tsk = _.clone(task)
    delete tsk.id
    tsk.status = "dateset"
    tsk.photos = []
    tsk.edit = true;
    this.ntask = tsk
    if(!_.isUndefined(this.instances[0])) this.instances[0].open()
  }
},
computed: {
    listItems() {
      var that = this;
      return _.filter(
        _.orderBy(this.interventions, this.orderby, this.order),
        function(item){
          var inWorkers = (_.intersection(that.selected_workers, item.worker_ids).length > 0 || that.selected_workers.length == 0);
          var inName = item.keywords2.toUpperCase().indexOf(that.customersearch.toUpperCase()) >= 0;
          var inAddress = item.keywords.toUpperCase().indexOf(that.addrsearch.toUpperCase()) >= 0;
          var inKinds = (_.intersection(that.selected_kinds, item.types).length > 0 || that.selected_kinds.length == 0);
          var inNumberIds =  (item.number || item.id.toString()).toUpperCase().indexOf(that.idsearch.toUpperCase()) >= 0;
          var priceMatch = item.price.toString().toUpperCase().indexOf(that.pricesearch.toUpperCase()) >= 0
          var inDates = moment(item.date).isBetween(that.from, that.to, 'date', '[]')
          return inWorkers && inName  &&  inAddress && inKinds && inNumberIds &&  priceMatch && inDates;
        }
      );
    },
    customersList() {
        var groupos = _.groupBy(this.places, 'customer_id');
        var items = []
        for( var group_id in groupos){
            items.push({"id": group_id, "name": _.first(groupos[group_id]).customer_name, "status": "active", "places": groupos[group_id]})
        }
        return items;
    }
},
mixins: [Vue2Filters.mixin],
}
</script>

<style scoped>
.login_button{
  color: red;
}
p {
  margin: 0em;
}
thead{
  background-color: #DADADA;

}
thead th{
  font-weight: 300;
  padding-top: 5px;
  padding-bottom: 5px;
  vertical-align: baseline;
}
th span{
  padding-left: 5px !important;
}
td{
  padding-left: 15px !important;
}
thead .input-field{
  margin-top: unset;
  margin-bottom: unset;
}
.maincontainer{
  padding-top: 10px;
  margin-top: 10px;
  margin-right: 33px;
  margin-bottom: 33px;
  margin-left: 33px;
}
a {
  color: black;
}
.btn-large{
  background-color: #c22026;
  color: black;
}
select {
  display: block;
  padding-top: 0px;
  padding-bottom: 0 0 0 0;
  height: 35px;
  border-radius: 4px !important;
  border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
}
.star{
    -webkit-text-stroke: black;
    -webkit-text-stroke-width: 1px;
    user-select: none;
}
</style>
